import React, { Component } from 'react'
// import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	// faChevronLeft,
	// faChevronRight,
	faPlus,
	faMinus,
	faShoppingCart,
	faCreditCard
  } from "@fortawesome/free-solid-svg-icons";

import { cartService } from '../../_services/cart.service';
import { productService } from '../../_services/product.service';
import { formatPrice } from "../../_helpers";

import Swal from 'sweetalert2/dist/sweetalert2.js'

export class ProductInformation extends Component {
	constructor(props) {
		super(props)
		this.state = {
			quantity: 1,
			cart: {
				items: []
			},
			alsoBought:{
				items: []
			}
		}

		this.handleAddToCartClick = this.handleAddToCartClick.bind(this);
	}

	quantityIncrement = () => {
		if (this.state.quantity >= 20) {
		} else {
		  this.setState({ quantity: this.state.quantity + 1 });
		}
	};
	 
	quantityDecrement = () => {
		if (this.state.quantity <= 1) {
		} else {
			this.setState({ quantity: this.state.quantity - 1 });
		}
	}
	
	UpdateValue = (e) => {
		this.setState({ quantity: e.target.value });
	}

	addToCart(id, name, slug, image, cost) {
		const { cart } = this.state;
	
		if (!cart.items) {
		  Swal.fire({
			position: "top-end",
			icon: "error",
			title: "An error occured when retrieving your cart.",
			showConfirmButton: false,
			timer: 3000,
		  });
		  return false;
		}
		
		cartService.getItems().then(({ items, ...cart }) => {
		  const newItems = items.reduce((acc, obj) => {
			const index = acc.findIndex((v) => v.p === obj.p);
			if (index > -1) {
			  acc[index].q += obj.q
			  return acc;
			};
			return acc.concat(obj);
		  }, [{
			p: id,
			n: name,
			i: image,
			s: slug,
			c: cost,
			q: 1,
		  }]);
	
		  cartService.addItem({
			...cart,
			items: newItems
		  }).then((result) => {
			if (result.success) {
			  Swal.fire({
				position: "top-end",
				icon: "success",
				title: name + " has been added to your shopping cart.",
				showConfirmButton: false,
				timer: 1500,
			  });
			}
		  });
		});
	  }

//   addToCart(id, name, slug, image, cost, callback) {
//     const { cart, quantity = 1 } = this.state;

//     if (!cart.items) {
//       Swal.fire({
//         position: "top-end",
//         icon: "error",
//         title: "An error occured when retrieving your cart.",
//         showConfirmButton: false,
//         timer: 3000,
//       });
//       return false;
//     }
    
//     cartService.getItems().then(({ items, ...cart }) => {
//       const newItems = items.reduce((acc, obj) => {
//         const index = acc.findIndex((v) => v.p === obj.p);
//         if (index > -1) {
//           acc[index].q += obj.q
//           return acc;
//         };
//         return acc.concat(obj);
//       }, [{
//         p: id,
//         n: name,
//         i: image,
//         s: slug,
//         c: cost,
//         q: quantity,
//       }]);

//       cartService.addItem({
//         ...cart,
//         items: newItems
//       }).then((result) => {
//         if (result.success) {
//         	if (callback) {
//         		return callback()
//         	}

//           Swal.fire({
//             position: "top-end",
//             icon: "success",
//             title: name + " has been added to your shopping cart.",
//             showConfirmButton: false,
//             timer: 1500,
//           });
//         }
//       });
//     });
//   }

handleAddToCartClick = (productId, callback) => {
    console.log(typeof productId);
    console.log(productId);
    console.log(this.state.quantity);

    cartService.getAllCart()
      .then(nonce => {
        console.log('Fetched nonce:', nonce); // Ensure nonce is fetched
        // Add the product to the cart using the fetched nonce
        return cartService.addToCart(productId, this.state.quantity, nonce);
      })
      .then(data => {
        console.log('Product added to cart:', data);
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: data.name + " has been added to your shopping cart.",
          showConfirmButton: false,
          timer: 1500,
        });

        // Call the callback if provided
        if (callback) {
          callback();
        }
      })
      .catch(error => {
        console.error('Failed to add product to cart:', error);
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "An error occurred when retrieving your cart.",
          showConfirmButton: false,
          timer: 3000,
        });
      });
  };
	
	componentDidMount() {
		// productService.getSample({ limit: 6 }).then(alsoBought => this.setState({ alsoBought }))
		// cartService.getItems().then(cart => this.setState({ cart }))
		productService.getAlsoBought({ limit: 6}).then(products => this.setState({ alsoBought: { items: products}  }))
		// productService.getAllProducts({ page: 1, perPage: 20}).then(products => console.log(products))
	}

    render() {
		const product = this.props.product;
		const {alsoBought} = this.state;
		// const  quantityIncrement = this.props.quantityIncrement

        return (
            <React.Fragment>
			    { product && product.name &&
					<section className="single-product-info py-5 mt-5">
						<div className="container">
							<div className="d-flex single-product-info-navbar">
								<h2>Product Information</h2>
								<ul className="nav justify-content-end ml-auto" id="myTab">
									<li className="nav-item pr-5">
										<a className="nav-link pb-4 active" id="description-tab" data-toggle="tab" href="#new-arrivals" role="tab" aria-controls="new arrivals" aria-selected="true"><h4>Description</h4></a>
									</li>
									<li className="nav-item">
										<a className="nav-link  pb-4" id="specials-tab" data-toggle="tab" href="#specials" role="tab" aria-controls="specials" aria-selected="false"><h4>Technical Specs</h4></a>
									</li>										
								</ul>					
							</div>					
							<div className="tab-content">
								<div className="tab-pane fade active show" id="new-arrivals"
								role="tabpanel" aria-labelledby="new-arrivals-tab"
								dangerouslySetInnerHTML={{__html: product.description || ''}}
								>
								</div>
								
								<div  className="tab-pane fade" id="specials" 
								role="tabpanel" aria-labelledby="specials-tab"dangerouslySetInnerHTML={{__html: product.meta_data.length > 0 ? product.meta_data[0].value : '' }} >
										
								</div>
							</div>						
							<div className="d-flex align-items-center justify-content-between bg-white py-3 px-5">
								<div className="d-flex"><h2>{formatPrice(product.price, { minimumFractionDigits: 0 })}</h2></div>
								<div className="d-flex input-group my-3 quantity-counter">
									<div className="input-group-prepend">
										<label className="input-group-text bg-transparent pl-0" htmlFor="inputGroupSelect01">Quantity:</label>
									</div>
									<input type="text" className="form-control"placeholder={this.state.quantity} aria-label="" aria-describedby="" />
									<div className="input-group-append" id="button-addon4">
									<button className="btn btn-outline-secondary"  onClick={this.quantityDecrement} type="button"> <FontAwesomeIcon icon={faMinus} /> </button>
										<button className="btn btn-outline-secondary" onClick={this.quantityIncrement}  type="button"> <FontAwesomeIcon icon={faPlus} /> </button>	
									</div>
								</div>

								{product.stock_quantity > 0 ? (
									<div className="d-flex pricing-btn-group">
										<button className="btn btn-primary btn-lg mr-2 btn-block" 
										//onClick={() => this.addToCart(product._id, product.name, product.slug, product.mainImage, product.price)}
										onClick={() => {
											this.handleAddToCartClick(product.id)
					
										  }}
										>
											<FontAwesomeIcon icon={faShoppingCart}/> ADD TO CART
										</button>
										<button className="btn btn-primary btn-lg btn-block btn-paypal m-0" onClick={() => this.handleAddToCartClick(product.id, () => (window.location = '/checkout'))}>
											<FontAwesomeIcon icon={faCreditCard} /> CHECK OUT
											{/* Check out with <img src="/korg_img/images/paypal.svg" width="70" alt="..." /> */}
										</button>
									</div>
								) : (
									<div className="d-flex pricing-btn-group">
										<button disabled className="btn btn-primary btn-lg mr-2 btn-block"><FontAwesomeIcon icon={faShoppingCart}/> ADD TO CART</button>
										<button disabled className="btn btn-primary btn-lg btn-block btn-paypal m-0">
											<FontAwesomeIcon icon={faCreditCard} /> CHECK OUT
											{/* Check out with <img src="/korg_img/images/paypal.svg" width="70" alt="..." /> */}
										</button>
									</div>
								)}
							</div>
						</div>
					</section>
				}

				{ alsoBought.items && 
					<div className="single-product pb-5">
						<div className="container">
							<h2 className="mb-5">Customers Also purchased</h2>
							<div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xl-6">
								{alsoBought.items.map((item, index) => 
								<div className="col mb-sm-3" key={index}>
									<div className="card product-card-single mb-sm-3 h-100">
										{item.images &&
											<img src={item.images.length > 0 ? item.images[0].src : ""} className="card-img-top" alt="..." onClick={() => (window.location = "/product/" + item.slug)}/>
										}
										<div className="card-body">
											<h5 className="card-title" onClick={() => (window.location = "/product/" + item.slug)}>{item.name}</h5>
										</div>
										<div className="card-footer">
											<p className="card-text price mb-1"><strong>{formatPrice(item.price, { minimumFractionDigits: 0 })}</strong></p>
											<button disabled={item.stock <= 0} onClick={() => {
												if (item.stock <= 0) return;
												this.addToCart(item._id, item.name, item.slug, item.images, item.price)
											}} className="btn btn-primary">Add to Cart</button>
										</div>
									</div>
								</div>	
								)}																																
							</div>
						</div>
					</div>
				}

            </React.Fragment>   
        )
    }
}

export default ProductInformation;
